import {getInteractionId} from '@servicenow/ui-metrics';
import {dispatchError, locations} from '@servicenow/ui-internal';
import log from '../log';
import {effectRunner} from '../effects';

function sandboxEffect(effect, dispatch, action, host) {
	const {
		type: actionType,
		meta: {effectType = ''},
		payload = {}
	} = action;
	let location = '';
	let details = {};

	if (effectType === locations.EVENT) {
		const {event} = payload;
		const {type} = event;
		location = locations.EVENT;
		details = {type, event};
	} else {
		location = locations.EFFECT;
		details = {actionType};
	}

	return function sandboxedEffect(...args) {
		try {
			// there can be multiple handlers for a given action type defined
			// by multiple behaviors; we only want to apply the options specific
			// to the effects for a single behavior, type, and effect combination
			const {options} = effect;
			if (options) {
				const {payload, meta} = args[args.length - 1].action;

				if (meta.options === null || meta.options === undefined) meta.options = options;

				if (payload === null || payload === undefined) {
					args[args.length - 1].action.payload = {options}; // eslint-disable-line no-param-reassign
				} else if (typeof payload === 'object') {
					// TODO: payload.options could have be applied from a previous behavior
					// or it could be part of the payload dispatched; not sure what to log
					// or how to properly handle this scenario. if options were part of the metadata
					// instead it would solved the problem.
					// if (typeof payload.options === 'object')
					payload.options = options;
				}
			}

			const transactionCtx = {
				interactionId: getInteractionId(action.meta),
				host,
				type: action.type
			};
			effectRunner(effect, transactionCtx, ...args);
		} catch (error) {
			dispatchError(error, {
				dispatch,
				host,
				location,
				details,
				metadata: {internal: true},
				log
			});
		}
	};
}

export {sandboxEffect};
